var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0439 10V13H14.0519",
    stroke: "#353C47",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85386 17H4.04616C3.23826 17 2.46351 16.6628 1.89224 16.0627C1.32098 15.4626 1 14.6487 1 13.8L1 5C1 2.79086 2.79086 1 5 1H11.6616C12.4694 1 13.2442 1.33712 13.8154 1.93728C14.3867 2.53736 14.7077 3.35128 14.7077 4.2V5",
    stroke: "#353C47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6H3.30979C3.85512 6 4.37808 6.26543 4.76368 6.73795C5.14929 7.21048 5.36595 7.8514 5.36595 8.5197C5.36595 9.18791 5.14929 9.82883 4.76368 10.3014C4.37808 10.7739 3.85512 11.0394 3.30979 11.0394H1",
    stroke: "#353C47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5621 11.625C16.5621 14.3298 14.5836 16.4375 12.243 16.4375C9.90231 16.4375 7.92383 14.3298 7.92383 11.625C7.92383 8.92016 9.90231 6.8125 12.243 6.8125C14.5836 6.8125 16.5621 8.92016 16.5621 11.625Z",
    stroke: "#353C47"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/pendingIcon.8b2ccb90a8f6eb14c422063e6be5e5c0.svg";
export { ForwardRef as ReactComponent };